import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const BiologicalMonitoring = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceBiologicalReset',
      isReset: true,
      buttonText: 'Reset All Biological Data',
      features: [
        'Remove All Biological Data'
      ]
    },
    {
      demo: 'practiceBiologicalDemo',
      isReset: false,
      buttonText: 'Prepare Biological Section for a Demo',
      features: [
        'Scenario for Demo',
        '1 autoclave with 1 fail/invalid test result and rest of test results are passed'
      ]
    }
  ]

  return (
    <DemoCard headerText='Biological' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default BiologicalMonitoring